import React, { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconEditorLink = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 24 24"
      data-fill-none
    >
      <path
        d="M11.2041 8.81597L12.3696 7.65037C13.4685 6.55144 15.2502 6.55144 16.3492 7.65037C17.4482 8.74931 17.4482 10.531 16.3492 11.63L15.1837 12.7956"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.796 15.1837L11.6305 16.3493C10.5315 17.4482 8.7498 17.4482 7.65086 16.3493C6.55193 15.2504 6.55193 13.4686 7.65086 12.3697L8.81637 11.2041"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5919 10.4082L10.4082 13.5919"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  ))
);

IconEditorLink.displayName = 'IconEditorLink';
